/**
 * Capitalizes the first letter of each word in a sentence.
 * If the whole word is uppercase, it will be converted to title case.
 * But if the word simply contains multiple uppercase letters, it will capitalize the first letter.
 * "hello WORLD" -> "Hello World"
 * "mccordsville" -> "Mccordsville"
 * "john O'NEAL" -> "John O'Neal"
 * "IPHONE" -> "Iphone"
 * "McDonalds" -> "McDonalds"
 */
export function titleCase(str, ...exceptions) {
    if (!str)
        return "";
    const exceptionSet = new Set(exceptions.map((e) => e.toLowerCase()));
    return str
        .split("_")
        .map((word) => word
        // Replace non-alphanumeric characters with a space
        .replace(/[^a-zA-Z0-9\s]+/g, " ")
        .split(/\s+/)
        .map((subWord) => {
        // If it's an exception, return it unchanged
        if (exceptionSet.has(subWord.toLowerCase()))
            return subWord;
        // If fully uppercase, normalize to Title Case
        if (subWord.toUpperCase() === subWord) {
            return (subWord.charAt(0).toUpperCase() +
                subWord.slice(1).toLowerCase());
        }
        // Otherwise, capitalize normally
        return subWord.charAt(0).toUpperCase() + subWord.slice(1);
    })
        .join(" "))
        .join(" ");
}
// Takes the first letter of each meaningful word, capitalizes
// them, and puts them together
export function createAcronym(sentence, limit) {
    limit = limit ? limit : 2;
    // List of filler words to remove
    const fillerWords = new Set(["of", "the", "an", "a", "and", "-"]);
    // Split the sentence into words, filter out filler words, and create the acronym
    return sentence
        .split(" ")
        .filter((word) => !fillerWords.has(word.toLowerCase()))
        .map((word) => word.charAt(0).toUpperCase())
        .join("")
        .substring(0, limit);
}
// Creates a short address string from the given address object
// Filters out empty fields
export function createShortAddressString(address) {
    const { city, state_name, stateName, state_id, stateId, postal_code, postalCode } = address;
    const name = state_name || stateName;
    const id = state_id || stateId;
    const code = postal_code || postalCode;
    const cityString = city ? `${titleCase(city)}` : "";
    const stateString = id
        ? `${id.toUpperCase()}`
        : name
            ? `${titleCase(name)}`
            : "";
    const postalCodeString = code ? code : "";
    // Build address with proper punctuation
    let result = cityString;
    if (stateString && result)
        result += `, ${stateString}`;
    else if (stateString)
        result += stateString;
    if (postalCodeString && result)
        result += `. ${postalCodeString}`;
    else if (postalCodeString)
        result += postalCodeString;
    return result;
}
export function Upper(string) {
    return string.toUpperCase();
}
export function createSingleLinePreview(value) {
    if (!value)
        return "";
    return value
        .replace(/\s*\n+\s*/g, " ")
        .replace(/\s+/g, " ")
        .trim();
}
